export const GET_RIGHT_NAVIGATION = 'GET_RIGHT_NAVIGATION';
export const GET_THEME = 'GET_THEME';
export const GET_LOGO = 'GET_LOGO';

export const GET_RELATED_CONTENT = 'GET_RELATED_CONTENT';

export const GET_STRUCTURE = 'GET_STRUCTURE';

export const GET_LEVEL_ONES = 'GET_LEVEL_ONES';
export const GET_LEVEL_TWOS = 'GET_LEVEL_TWOS';
export const GET_LEVEL_THREES = 'GET_LEVEL_THREES';
export const GET_LEVEL_FOURS = 'GET_LEVEL_FOURS';

export const GET_GLOSSARY = 'GET_GLOSSARY';
export const GET_CLIENT_DOCUMENTS = 'GET_CLIENT_DOCUMENTS';
export const GET_CLIENT_PAGES = 'GET_CLIENT_PAGES';

// export const SET_PREVIEW_MODE = 'SET_PREVIEW_MODE';

export const SET_CLIENT_LOADING = 'SET_CLIENT_LOADING';
export const SET_CLIENT_PAGES_LOADING = 'SET_CLIENT_PAGES_LOADING';

export const GET_BOOKMARKS_DOCS = 'GET_BOOKMARKS_DOCS';

export const BUY_ADDITIONAL_QUERIES = 'BUY_ADDITIONAL_QUERIES';